<script setup lang="ts">
import axios from 'axios';
import KpModal from '@kp/geofy-vuejs-lib/tg-system/components/KpModal.vue';
import { ref, type Ref } from 'vue';
import { apiUrl } from '@/helpers/api';

const emit = defineEmits(['download-complete', 'download-error']);

const loadingText: Ref<string> = ref('datei_wird_erstellt');
const generatingPDF: Ref<boolean> = ref(false);

function downloadFile(url: string, message: string, params = []) {
    loadingText.value = message;
    generatingPDF.value = true;

    axios({
        url: apiUrl(url),
        method: 'GET',
        responseType: 'blob',
        params: params
    })
        .then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement('a');
            let fileName = 'unknown';

            const contentDisposition = response.headers['content-disposition'];
            if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                if (fileNameMatch.length === 2) {
                    fileName = fileNameMatch[1];
                }
            }
            fileLink.href = fileURL;
            fileLink.setAttribute('download', fileName);
            document.body.appendChild(fileLink);

            fileLink.click();
            generatingPDF.value = false;

            emit('download-complete');
        })
        .catch((error) => {
            generatingPDF.value = false;
            emit('download-error', error);
        });
}

defineExpose({
    downloadFile
});
</script>

<template>
    <KpModal v-model="generatingPDF">
        {{ $t(loadingText) }}
    </KpModal>
</template>
